export default __webpack_public_path__ + "static/media/angers5.c90f5ec6.jpg";